'use client';

import Link from 'next/link';
import { useAuth } from '@/lib/hooks/useAuth';
import styles from './Alert.module.css';

const Alert = () => {
  const { user, userData, loading } = useAuth();

  if (loading) {
    return (
      <Link href="/signin" className={styles.alert}>
        <span className={styles.text}>Member? Log in to your app</span>
        <span className={styles.arrow}>→</span>
      </Link>
    );
  }

  if (user) {
    const href = userData?.isAdmin ? '/crm/dashboard' : '/trainee/my-classes';
    const label = userData?.isAdmin ? 'Jump to the CRM' : 'Jump to Member Area';
    
    return (
      <Link href={href} className={styles.alert}>
        <span className={styles.text}>{label}</span>
        <span className={styles.arrow}>→</span>
      </Link>
    );
  }

  return (
    <Link href="/signin" className={styles.alert}>
      <span className={styles.text}>Member? Log in to your app</span>
      <span className={styles.arrow}>→</span>
    </Link>
  );
};

export default Alert;
